import styled from 'styled-components';

import {
    floorGameDuration as duration,
    floorGameEasing as easing,
    styledInteraction,
    styledLayout,
} from '@pkg/primitives';

import { tokens } from './tokens';

interface StyledNftCardProps {
    $compact?: boolean;
}

export const StyledNftCard = styled.div<StyledNftCardProps>`
    --yat_nft-card-glow-opacity: 0;
    --yat_nft-card-shine-opacity: 0;
    --yat_nft-card-content-gap: ${({ $compact }) =>
        $compact ? tokens.content.gap.compact : tokens.content.gap.default}px;

    z-index: ${tokens.zindex.card};
    position: relative;

    &:hover,
    &:focus-within {
        --yat_nft-card-glow-opacity: 0.4;
        --yat_nft-card-shine-opacity: 0.2;
    }

    // We may want to enable this only when "interactive".
    &::before {
        ${styledLayout.positionCover()};
        ${styledInteraction.interactionDisable};
        z-index: ${tokens.zindex.card};
        content: '';
        display: block;
        opacity: var(--yat_nft-card-glow-opacity);
        border-radius: ${tokens.card.radius}px;
        box-shadow: 0 2px 32px rgba(255, 255, 255, 0.2);
        transition: opacity ${duration.normal}ms ${easing.cubic};
    }
`;

export const Interior = styled.div`
    z-index: ${tokens.zindex.interior};
    position: relative;
    width: 100%;
    height: 100%;
    border-radius: ${tokens.card.radius}px;
    box-shadow: 0 4px 4px rgba(0, 0, 0, 0.2);
    overflow: hidden;

    // We may want to enable this only when "interactive".
    &::after {
        ${styledLayout.positionCover()};
        ${styledInteraction.interactionDisable};
        z-index: ${tokens.zindex.shine};
        content: '';
        display: block;
        background: radial-gradient(ellipse, rgba(255, 255, 255, 0.2), rgba(255, 255, 255, 0));
        mix-blend-mode: soft-light;
        opacity: var(--yat_nft-card-shine-opacity);
        transition: opacity ${duration.normal}ms ${easing.cubic};
    }
`;

export const Content = styled.div`
    z-index: ${tokens.zindex.content};
    position: relative;
    display: flex;
    flex-direction: column;
    gap: var(--yat_nft-card-content-gap);
    width: 100%;
    height: 100%;
`;
